// ── Telefone mask ─────────────────────────────────────────────────────────────
const telefoneFields = document.querySelectorAll('.form-estruturacao-credito [name="telefone"]');

telefoneFields.forEach((field) => {
  field.addEventListener('input', (event) => {
    const digits = event.target.value.replace(/\D/g, '').slice(0, 11);

    if (digits.length > 6) {
      event.target.value = `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    } else if (digits.length > 2) {
      event.target.value = `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    } else if (digits.length) {
      event.target.value = `(${digits}`;
    } else {
      event.target.value = '';
    }
  });
});

// ── CPF mask ──────────────────────────────────────────────────────────────────
const cpfFields = document.querySelectorAll('.form-estruturacao-credito [name="cpf"]');

cpfFields.forEach((field) => {
  field.addEventListener('input', (event) => {
    const digits = event.target.value.replace(/\D/g, '').slice(0, 11);

    if (digits.length > 9) {
      event.target.value = `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
    } else if (digits.length > 6) {
      event.target.value = `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
    } else if (digits.length > 3) {
      event.target.value = `${digits.slice(0, 3)}.${digits.slice(3)}`;
    } else {
      event.target.value = digits;
    }
  });
});

// ── Form validation + AJAX submit ─────────────────────────────────────────────
const form = document.querySelector('.form-estruturacao-credito__form');

if (form) {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearErrors(form);

    if (!window.rbEstruturacaoCreditoAjax?.url) {
      showFeedback(form, 'Erro de configuração do formulário. Tente recarregar a página.', 'error');
      return;
    }

    const errors = validateForm(form);
    if (errors.length > 0) {
      errors.forEach(({ field, message }) => showFieldError(field, message));
      errors[0].field.focus();
      return;
    }

    const btn = form.querySelector('.form-estruturacao-credito__btn');
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Enviando...';

    const data = new FormData(form);
    data.set('action', 'rb_estruturacao_credito_form_submit');

    try {
      const response = await fetch(window.rbEstruturacaoCreditoAjax.url, {
        method: 'POST',
        body: data,
      });

      if (!response.ok) throw new Error('network');

      const json = await response.json();

      if (json.success) {
        showFeedback(form, json.data.message, 'success');
        form.reset();
      } else {
        const msg = json.data?.message || 'Ocorreu um erro. Tente novamente.';
        showFeedback(form, msg, 'error');
      }
    } catch (err) {
      console.error('Estruturação de crédito form error:', err);
      showFeedback(form, 'Ocorreu um erro de conexão. Tente novamente.', 'error');
    } finally {
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });
}

// ── Helpers ───────────────────────────────────────────────────────────────────
function validateForm(form) {
  const errors = [];
  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const rules = [
    { name: 'nome',      type: 'text',  message: 'Por favor, preencha este campo.' },
    { name: 'sobrenome', type: 'text',  message: 'Por favor, preencha este campo.' },
    { name: 'email',     type: 'email', message: 'Informe um endereço de email válido.' },
    { name: 'cpf',       type: 'cpf',   message: 'Informe um CPF válido.' },
    { name: 'telefone',  type: 'phone', message: 'Informe um número de telefone válido.' },
  ];

  rules.forEach(({ name, type, message }) => {
    const field = form.querySelector(`[name="${name}"]`);
    if (!field) return;

    const digits = field.value.replace(/\D/g, '');
    let invalid = false;

    if (type === 'text')  invalid = field.value.trim() === '';
    if (type === 'email') invalid = !emailRe.test(field.value.trim());
    if (type === 'phone') invalid = digits.length > 0 && digits.length < 10;
    if (type === 'cpf')   invalid = digits.length > 0 && (digits.length !== 11 || !isValidCPF(digits));

    if (invalid) errors.push({ field, message });
  });

  return errors;
}

function isValidCPF(cpf) {
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) sum += parseInt(cpf.charAt(i)) * (10 - i);
  let rest = 11 - (sum % 11);
  if (rest >= 10) rest = 0;
  if (rest !== parseInt(cpf.charAt(9))) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) sum += parseInt(cpf.charAt(i)) * (11 - i);
  rest = 11 - (sum % 11);
  if (rest >= 10) rest = 0;
  if (rest !== parseInt(cpf.charAt(10))) return false;

  return true;
}

function showFieldError(field, message) {
  const container = field.closest('.form-estruturacao-credito__field');
  if (!container) return;
  container.classList.add('form-estruturacao-credito__field--error');
  const span = document.createElement('span');
  span.className = 'form-estruturacao-credito__error-msg';
  span.textContent = message;
  container.appendChild(span);
}

function clearErrors(form) {
  form.querySelectorAll('.form-estruturacao-credito__field--error').forEach((el) => {
    el.classList.remove('form-estruturacao-credito__field--error');
  });
  form.querySelectorAll('.form-estruturacao-credito__error-msg').forEach((el) => el.remove());

  const feedback = form.querySelector('.form-estruturacao-credito__feedback');
  if (feedback) {
    feedback.className = 'form-estruturacao-credito__feedback';
    feedback.textContent = '';
  }
}

function showFeedback(form, message, type) {
  const feedback = form.querySelector('.form-estruturacao-credito__feedback');
  if (!feedback) return;
  feedback.className = `form-estruturacao-credito__feedback form-estruturacao-credito__feedback--${type}`;
  feedback.textContent = message;
  feedback.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}
